import firebase from "firebase/app";
import "firebase/storage";

class UploaderService {
    uploadFile = async (files, path) => {
        const urls = [];

        for (let file of files) {
          const ref = await firebase.storage().ref(`documents/${path}/${this.generateUUID()}`);

          try {
            const task = await ref.put(file);
            const url = await task.ref.getDownloadURL();
            urls.push(url);
          } catch (err) {
            // gestire errore
            console.log(err);
          }
        }

        return urls;
      };

    generateUUID() {
        var dt = new Date().getTime();
        var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        });

        return uuid;
    }
}

export default new UploaderService();



// WEBPACK FOOTER //
// ./src/services/uploader.js